<mat-nav-list>
  @for (option of menus.items; track option) {
    <a mat-list-item (click)="openLink($event, option)">
      <span matListItemTitle>{{ option.text }}</span>
    </a>
  }
</mat-nav-list>
